import { PageHeader } from '../../components/ui';
import { DeploymentCard } from '../settings/PlatformCards';

/**
 * The deployment's own page — version, migrations and the production
 * readiness checks from the deploy runbook, moved whole from the card that
 * used to sit in Settings.
 */
export function DeployPage() {
  return (
    <>
      <PageHeader
        title="Deployment"
        description="This installation itself — version, migrations, and the runbook's readiness checks."
      />
      <DeploymentCard />
    </>
  );
}
